module.exports = __webpack_public_path__ + "img/three1Green.fb784ab4.jpg";